<template>
  <div>
    <custom-head :item="item" :type="type" @deleteItem="(item) => deleteItem(item)">
      <div>
        <a-tabs style="width: 100%" v-model="tabValue" size="small" @change="handleTabChange">
          <a-tab-pane key="1" :tab="$t('page_area_machine_num')"> </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('page_area_alarm_num')"> </a-tab-pane>
          <a-tab-pane key="3" :tab="$t('page_device_type_num')"> </a-tab-pane>
        </a-tabs>
      </div>
    </custom-head>
    <a-select
      v-model="modelType"
      style="width: 150px;margin-left: 8px;"
      @change="getList"
    >
      <a-select-option
        v-for="(item, index) in tabValue==='1'? deviceNumOptions : tabValue === '2'? issueTypeOptions : deviceTypeOptions"
        :key="index"
        :value="item.value">
        {{ item.label }}
      </a-select-option>
    </a-select>
    <div class="total-regions-box calc-height">
      <div style="width:calc(100% - 300px);height:100%" ref="myChart"></div>
      <div class="legend" :style="{ JustifyContent: tabValue==='2'? 'center': '' }">
        <div class="box" v-for="(item, index) in echartData" :key="index">
          <div class="item">
            <div class="icon" :style="{ backgroundColor: color[parseInt(index % 9)] }"/>
            <div class="name">{{ $t(item.name) }}</div>
            <div class="value" :style="{ color: color[parseInt(index % 9)] }">
              {{ item.value }}
            </div>
          </div>
          <div class="subscribe" v-if="item.deviceTypeDataList && item.deviceTypeDataList.length>0">
            <div class="sub-item" v-for="( i, index ) in item.deviceTypeDataList" :key="index">
              <span class="name">{{ $t(i.name) }} ：</span>
              <span class="value">{{i.value}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './cardmixin.vue'
import { AlarmHistoryServiceProxy } from '@/service-proxies/app-v2/mdc.service-proxies'
import { MachineServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
const ahsp = new AlarmHistoryServiceProxy()
const msp = new MachineServiceProxy()

export default {
  name: 'total-regions',
  mixins: [mixin],
  data() {
    return {
      color: [
        '#50E3C0',
        '#B7EA87',
        '#7DD420',
        '#84A5FE',
        '#D3AEF8',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
      ],
      myChart: null,
      echartData: [],
      tabValue: '1',
      modelType: 1,
    }
  },
  props: {
    unit: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.myChart = this.$echarts.init(this.$refs.myChart)
    this.getList()
  },
  watch: {
    chartOption: {
      handler(val) {
        if (this.myChart) {
          this.myChart.setOption(val, true)
        }
      },
      deep: true
    },
    unit: {
      handler() {
        if (this.myChart) {
          setTimeout(() => {
            this.myChart.resize()
          }, 300)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    chartOption() {
      const map = {'1': this.$t('total_machine'), '2': this.$t('page_ops_custom_device'), '3':  this.$t('iot_device'), '4': this.$t('page_business_device_type')}
      let title = '';
      if(this.tabValue === '1') {
        title = map[this.modelType];
      } else if(this.tabValue === '2') {
        title = this.$t('total_alarm');
      } else {
        title = this.$t('page_device_type_num')
      }

      let formatNumber = function(num) {
        let reg = /(?=(\B)(\d{3})+$)/g
        return num.toString().replace(reg, ',')
      }
      let total = this.echartData.reduce((a, b) => {
        return a + b.value * 1
      }, 0)

      let option = {
        color: this.color,
        title: [
          {
            text: '{val|' + formatNumber(total) + '}\n{name|' + title + '}',
            top: 'center',
            left: 'center',
            textStyle: {
              rich: {
                align: 'canter',
                name: {
                  fontSize: 15,
                  fontWeight: 'bold',
                  color: '#666666',
                  padding: [10, 0]
                },
                val: {
                  fontSize: 32,
                  fontWeight: 'bold',
                  color: '#5396E3'
                }
              }
            }
          }
        ],
        series: [
          {
            type: 'pie',
            radius: ['60%', '85%'],
            center: ['50%', '50%'],
            data: this.echartData,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderWidth: 2
              }
            },
            labelLine: {
              normal: {
                length: 20,
                length2: 120,
                lineStyle: {
                  color: '#e6e6e6'
                }
              }
            },
            label: {
              show: false
            }
          }
        ]
      }
      return option
    },
    deviceNumOptions() {
      return [
        {
          label: this.$t('page_all'),
          value: 1,
        },
        {
          label: this.$t('page_ops_custom_device'),
          value: 2,
        },
        {
          label: this.$t('iot_device'),
          value: 3,
        },
        {
          label: this.$t('page_business_device_type'),
          value: 4,
        }
      ]
    },
    issueTypeOptions() {
      // 0: 全部 1:错误 2:警告 3:提示
      return [
        {
          value: '',
          label: this.$t('page_all')
        },
        {
          value: 1,
          label: this.$t('page_error')
        },
        {
          value: 2,
          label: this.$t('page_warning')
        },
        {
          value: 3,
          label: this.$t('page_tip')
        },
      ]
    },
    deviceTypeOptions() {
      // 1:全部 2:自定义设备 3:网关设备
      return [
        {
          label: this.$t('page_all'),
          value: 1,
        },
        {
          label: this.$t('page_ops_custom_device'),
          value: 2,
        },
        {
          label: this.$t('iot_device'),
          value: 3,
        },
      ]
    },
  },
  methods: {
    async getList() {
      this.echartData = [];
      this.setOption();
      if(this.tabValue === '1') {
        msp.getAreaMachineStatistics(this.modelType).then(data=>{
          this.echartData = data;
          this.setOption();
        })
      } else if(this.tabValue === '2') {
        ahsp.getAreaAlarmStatistics(this.modelType).then(data=>{
          this.echartData = data;
          this.setOption();
        })
      } else {
        msp.getDeviceTypeMachineStatistics(this.modelType).then(data=>{
          this.echartData = data;
          this.setOption();
        })
      }
    },
    setOption() {
      this.$nextTick(()=>{
        this.myChart.clear();
        this.myChart.setOption(this.chartOption);
        this.myChart.resize();
      })
    },
    handleTabChange(e) {
      this.modelType = e==2 ? '' : 1;
      this.getList();
    },
  }
}
</script>

<style lang="less" scoped>
.total-regions-box {
  width: 100%;
  height: 100%;
  display: flex;
  .legend{
    flex: 1;
    overflow: auto;
    display: flex;
    flex-direction: column;
  }
  .item{
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    .icon {
      width: 10px;
      height: 10px;
      border-radius: 5px;
    }
    .name {
      font-size: 16px;
      padding: 0 20px 0 10px;
      color: #666666;
    }
    .value {
      font-size: 24px;
      line-height: 24px;
      font-weight: 500;
    }
  }
  .subscribe{
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    padding: 0 20px 8px;
    overflow: auto;
    .sub-item{
      display: flex;
      margin-right: 8px;
    }
  }
}
.calc-height{
  height: calc(100% - 32px);
}
/deep/ .ant-tabs {
  overflow: inherit;
}

/deep/ .ant-tabs-bar {
  bottom: -1px;
  border-bottom: 1px solid #d9d9d9;
}

/deep/ .ant-tabs .ant-tabs-small-bar .ant-tabs-tab {
  padding: 9px 16px 8px;
  margin: 0;
}
/deep/ .ant-tabs-nav .ant-tabs-tab {
  border-right: 1px solid #d9d9d9;
}

/deep/ .ant-tabs-nav .ant-tabs-tab-active {
  background-color: #fff;
}

/deep/ .ant-tabs-ink-bar {
  top: -1px !important;
  z-index: 99;
  background-color: #4a90e2;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  bottom: auto;
  height: 4px;
}
</style>
